import { availableDateFieldsType } from "@/propTypes";
import { Form, Input, Select } from "antd";
import { useIntl } from "react-intl";

import { FormFieldContainer } from "./styled";

export const DateFormField = ({ availableDateFields }) => {
  const intl = useIntl();
  const options = [
    {
      label: intl.formatMessage({
        id: "newFormField.createdDate",
        defaultMessage: "Created Date",
      }),
      value: "CreatedAt",
    },
  ].concat(availableDateFields);

  return (
    <FormFieldContainer>
      <Form.Item
        name="label"
        label={intl.formatMessage({ id: "newFormField.fieldLabel" })}
        rules={[
          {
            required: true,
            message: intl.formatMessage({
              id: "newFormField.fieldLabelRequired",
            }),
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="placeholder"
        label={intl.formatMessage({ id: "newFormField.placeholder" })}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="requiredValidationText"
        label={intl.formatMessage({ id: "newFormField.validationErrorText" })}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="startDateValidationField"
        label={intl.formatMessage({
          id: "newFormField.startDateValidationField",
        })}
      >
        <Select style={{ maxWidth: 500 }} options={options}></Select>
      </Form.Item>
      <Form.Item
        name="endDateValidationField"
        label={intl.formatMessage({
          id: "newFormField.endDateValidationField",
        })}
      >
        <Select style={{ maxWidth: 500 }} options={options}></Select>
      </Form.Item>
    </FormFieldContainer>
  );
};

DateFormField.propTypes = {
  availableDateFields: availableDateFieldsType,
};
